/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { SearchOutlined } from '@ant-design/icons'
import { Input, Checkbox, notification } from 'antd'
import store from 'store'
import algoliasearch from 'algoliasearch/lite'
import { InstantSearch, connectSearchBox, Highlight, connectHits } from 'react-instantsearch-dom'
import style from './style.module.scss'
import Thumbnail from './Thumbnail'

const mapStateToProps = ({ files }) => ({
  results: files.results,
  refreshIndex: files.refreshIndex,
})

const searchClient = algoliasearch('X123A7EMIJ', store.get('search'))

const Search = ({ intl: { formatMessage }, refreshIndex }) => {
  console.log('is Algolia index refreshed = ', refreshIndex)
  const [showSearch, setShowSearch] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [showResults, setShowResults] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [searchText, setSearchText] = useState('')
  const inputRef = useRef('')

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false)
    return () => document.removeEventListener('keydown', handleKeyDown)
  })

  const showLiveSearch = () => {
    setShowSearch(true)
    setTimeout(() => {
      inputRef.current.focus()
    }, 300)
  }

  const changeSearchText = (event, refine) => {
    refine(event.currentTarget.value) // this line is ok
    // if i need the text or i need to set an attribute to show or no the result everything is broken
    // setSearchText(event.currentTarget.value); // With this line nothing is working any more
  }

  const SearchBox = ({ currentRefinement, refine }) => (
    <form noValidate action="" role="search">
      <input
        type="search"
        id="livesearchInput"
        className={style.searchInput}
        value={currentRefinement} // if i put something else here like searchText variable nothing is working as expected
        onChange={event => changeSearchText(event, refine)}
        placeholder={formatMessage({ id: 'topBar.typeToSearch' })}
        ref={inputRef} // ref seems ok like this
      />
    </form>
  )

  const CustomSearch = connectSearchBox(SearchBox)

  const hideLiveSearch = () => {
    // searchInput.blur()
    setShowSearch('')
    setSearchText('')
  }

  const handleKeyDown = event => {
    if (showSearch) {
      console.log('event', event)
      if (event.keyCode) {
        const key = event.keyCode.toString()
        if (key === '27') {
          hideLiveSearch()
        }
        if (key === '13') {
          // hideLiveSearch()
        }
      }
    }
  }

  const Results = ({ hit }) => {
    const { tags } = hit
    return (
      <Link to={`/files/detail/${hit.objectID}`} onClick={() => setShowSearch(false)}>
        <div className={style.resultContent} key={hit.name}>
          <div className={style.resultThumb}>
            <Thumbnail imageUrl={hit.image} />
          </div>
          <div className={style.result}>
            <div className={style.resultText}>
              <strong>{hit.name}</strong>
            </div>
            <div className={style.resultTags}>
              <strong>TAGS: </strong>
              {tags.slice(0, 6).join(', ')}...
            </div>
          </div>
        </div>
      </Link>
    )
  }

  /**
   *
   * Hit are not refreshed when refresh is set to true.
   * and searchClient.clearCache is not set
   *
   */
  const Hit = ({ hits }) =>
    hits.map((hit, index) =>
      index % 1 === 0 || index === 0 ? (
        <div className="col-lg-4" key={`${hit.objectID}`}>
          <Results hit={hit} />
        </div>
      ) : (
        <Results hit={hit} key={`${hit.objectID}`} />
      ),
    )

  const CustomHits = connectHits(Hit)

  // cache need to be refreshed otherwise Hit will still be displayed.
  searchClient.clearCache()

  return (
    <InstantSearch searchClient={searchClient} indexName="dev_mobidoc" refresh={refreshIndex}>
      <div className="d-inline-block me-4">
        <Input
          className={style.extInput}
          placeholder={formatMessage({ id: 'topBar.typeToSearch' })}
          prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          style={{ width: 200 }}
          onFocus={showLiveSearch}
        />
        <div
          className={`${
            showSearch ? `${style.livesearch} ${style.livesearchVisible}` : style.livesearch
          }`}
          id="livesearch"
        >
          <button className={style.close} type="button" onClick={hideLiveSearch}>
            <i className="icmn-cross" />
          </button>
          <div className="container-fluid">
            <div className={style.wrapper}>
              <CustomSearch />
              <ul className={style.options}>
                {/*                 <li className={style.option}>
                  <Checkbox checked>Search within app</Checkbox>
                </li> */}
                <li className={style.option}>Press enter to search</li>
              </ul>
              {false && (
                <div className={style.results}>
                  <div className={style.resultsTitle}>
                    <span>No Results Found</span>
                  </div>
                </div>
              )}
              {true && (
                <div className={style.results}>
                  <div className={style.resultsTitle}>
                    <span>Search Results</span>
                  </div>
                  <div className="row">
                    <CustomHits hitComponent={Hit} style={{ listStyle: 'none' }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </InstantSearch>
  )
}

export default connect(mapStateToProps)(injectIntl(Search))
